import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DeletePartyInput_InputAdapter_instance2pajmimmlhj5y as DeletePartyInput_InputAdapter_instance } from '../type/adapter/DeletePartyInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeletePartyMutation_VariablesAdapterClass;
function DeletePartyMutation_VariablesAdapter() {
  if (DeletePartyMutation_VariablesAdapterClass === VOID) {
    class $ {
      i6e(writer, value, customScalarAdapters, withDefaultValues) {
        writer.r47('input');
        obj(DeletePartyInput_InputAdapter_instance).p3z(writer, customScalarAdapters, value.h6e_1);
      }
    }
    initMetadataForObject($, 'DeletePartyMutation_VariablesAdapter');
    DeletePartyMutation_VariablesAdapterClass = $;
  }
  return DeletePartyMutation_VariablesAdapterClass;
}
var DeletePartyMutation_VariablesAdapter_instance;
function DeletePartyMutation_VariablesAdapter_getInstance() {
  return DeletePartyMutation_VariablesAdapter_instance;
}
//region block: init
DeletePartyMutation_VariablesAdapter_instance = new (DeletePartyMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  DeletePartyMutation_VariablesAdapter_instance as DeletePartyMutation_VariablesAdapter_instance39uaufo52kklq,
};
//endregion

//# sourceMappingURL=DeletePartyMutation_VariablesAdapter.mjs.map
